/**
 * @generated SignedSource<<90143c9303f3fa315eb0b3165eba9d57>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MoveLabelsToSkillsInput = {
  labelIds?: ReadonlyArray<string | null> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type moveLabelsToSkillsMutation$variables = {
  input: MoveLabelsToSkillsInput;
};
export type moveLabelsToSkillsMutation$data = {
  readonly moveLabelsToSkills: {
    readonly deletedLabelIds: ReadonlyArray<string | null> | null;
  } | null;
};
export type moveLabelsToSkillsMutation = {
  variables: moveLabelsToSkillsMutation$variables;
  response: moveLabelsToSkillsMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MoveLabelsToSkillsPayload",
    "kind": "LinkedField",
    "name": "moveLabelsToSkills",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedLabelIds",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "moveLabelsToSkillsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "moveLabelsToSkillsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e2eda0343563d050635c9851d6754b27",
    "id": null,
    "metadata": {},
    "name": "moveLabelsToSkillsMutation",
    "operationKind": "mutation",
    "text": "mutation moveLabelsToSkillsMutation(\n  $input: MoveLabelsToSkillsInput!\n) {\n  moveLabelsToSkills(input: $input) {\n    deletedLabelIds\n  }\n}\n"
  }
};
})();

(node as any).hash = "c89d7ad28c0f9506cfeaac45a1521cc5";

export default node;
